import React from 'react';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface ILocationListRecords {
	first?: number;
	last?: number;
	total?: number;
}

export interface ILocationListRecordsProps extends IBaseElementProps {
	records: ILocationListRecords;
}

const LocationListRecords: React.FC<ILocationListRecordsProps> = ({
	records,
}) => {

	return (
		<div className="location-list__records">
			{records && (
				<div className="location-list__records-container">
					Showing {records.first}-{records.last} of {records.total}
				</div>
			)}
		</div>
	);
};

export default LocationListRecords;
